import withStyles from '@mui/styles/withStyles';
import { APP_UI_FONT_STACK } from './shared/styles/fontStacks';

export const GLOBAL_FOCUS_RING = 'rgba(57, 114, 203, 0.58)';

export const globalStyleRules = theme => ({
  "@global": {
    html: {
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
      textRendering: 'optimizeLegibility'
    },
    body: {
      fontFamily: APP_UI_FONT_STACK,
      color: theme.palette.text?.primary || '#111827',
      backgroundColor: theme.palette.background?.default || '#f8fafc'
    },
    // Never erase the browser's keyboard affordance. A shared focus-visible
    // ring keeps custom and native controls discoverable without adding a ring
    // to ordinary pointer clicks.
    "*:focus-visible": {
      outline: `3px solid ${GLOBAL_FOCUS_RING}`,
      outlineOffset: 2
    },
    "::selection": {
      background: 'rgba(116, 148, 251, 0.25)',
      color: 'inherit'
    },
    ".text-white": {
      color: theme.palette.common.white
    },
    ".listItemLeftPadding": {
      paddingTop: `${theme.spacing(1.75)} !important`,
      paddingBottom: `${theme.spacing(1.75)} !important`,
      paddingLeft: `${theme.spacing(4)} !important`,
      [theme.breakpoints.down('md')]: {
        paddingLeft: `${theme.spacing(4)} !important`
      },
      "@media (max-width:  420px)": {
        paddingLeft: `${theme.spacing(1)} !important`
      }
    },
    ".container": {
      width: "100%",
      paddingRight: theme.spacing(4),
      paddingLeft: theme.spacing(4),
      marginRight: "auto",
      marginLeft: "auto",
      [theme.breakpoints.up("sm")]: {
        maxWidth: 540
      },
      [theme.breakpoints.up("md")]: {
        maxWidth: 720
      },
      [theme.breakpoints.up("lg")]: {
        maxWidth: 1170
      }
    },
    ".row": {
      display: "flex",
      flexWrap: "wrap",
      marginRight: -theme.spacing(2),
      marginLeft: -theme.spacing(2)
    },
    ".container-fluid": {
      width: "100%",
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      marginRight: "auto",
      marginLeft: "auto",
      maxWidth: 1370
    },
    ".lg-mg-top": {
      marginTop: `${theme.spacing(20)} !important`,
      [theme.breakpoints.down('lg')]: {
        marginTop: `${theme.spacing(18)} !important`
      },
      [theme.breakpoints.down('md')]: {
        marginTop: `${theme.spacing(16)} !important`
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: `${theme.spacing(14)} !important`
      }
    },
    ".lg-mg-bottom": {
      marginBottom: `${theme.spacing(20)} !important`,
      [theme.breakpoints.down('lg')]: {
        marginBottom: `${theme.spacing(18)} !important`
      },
      [theme.breakpoints.down('md')]: {
        marginBottom: `${theme.spacing(16)} !important`
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: `${theme.spacing(14)} !important`
      },
      
    },
    ".lg-p-top": {
      paddingTop: `${theme.spacing(20)} !important`,
      [theme.breakpoints.down('lg')]: {
        paddingTop: `${theme.spacing(18)} !important`
      },
      [theme.breakpoints.down('md')]: {
        paddingTop: `${theme.spacing(16)} !important`
      },
      [theme.breakpoints.down('sm')]: {
        paddingTop: `${theme.spacing(14)} !important`
      }
    },

    /* Polished hover helper used in Dashboard.js */
    ".hover-component": {
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      gap: theme.spacing(1),
      cursor: "default"
    },
    ".hover-component .info": {
      position: "absolute",
      top: "100%",
      left: 0,
      marginTop: theme.spacing(1),
      padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
      maxWidth: 360,
      width: "max-content",
      color: theme.palette.text.primary,
      background: "rgba(255,255,255,0.75)",
      border: `1px solid rgba(0,0,0,0.08)`,
      boxShadow: "0 8px 22px rgba(15, 23, 42, 0.12), 0 2px 6px rgba(15, 23, 42, 0.08)",
      backdropFilter: "saturate(180%) blur(8px)",
      WebkitBackdropFilter: "saturate(180%) blur(8px)",
      borderRadius: 12,
      lineHeight: 1.4,
      fontSize: 14,
      zIndex: 50,
      pointerEvents: "none",
      transform: "translateY(6px)",
      animation: "hoverFadeInUp 160ms ease-out both"
    },
    ".hover-component .info::after": {
      content: "''",
      position: "absolute",
      top: -6,
      left: 16,
      width: 10,
      height: 10,
      background: "inherit",
      transform: "rotate(45deg)",
      borderLeft: "1px solid rgba(0,0,0,0.06)",
      borderTop: "1px solid rgba(0,0,0,0.06)",
      boxShadow: "-2px -2px 2px rgba(15,23,42,0.02)"
    },
    ".hover-component:hover .TitleTextStyleSmall": {
      filter: "brightness(0.9)"
    },
    "@keyframes hoverFadeInUp": {
      from: {
        opacity: 0,
        transform: "translateY(8px)"
      },
      to: {
        opacity: 1,
        transform: "translateY(0)"
      }
    }
  }
});

function globalStyles() {
  return null;
}

export default withStyles(globalStyleRules, { withTheme: true })(globalStyles);
